export default __webpack_public_path__ + "static/media/Biology_01_05.2cbd920d.png";